import { render, staticRenderFns } from "./CardWithNumber.vue?vue&type=template&id=56d039b2&scoped=true&"
import script from "./CardWithNumber.vue?vue&type=script&lang=js&"
export * from "./CardWithNumber.vue?vue&type=script&lang=js&"
import style0 from "./CardWithNumber.vue?vue&type=style&index=0&id=56d039b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d039b2",
  null
  
)

export default component.exports